<script setup> 
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import TableSingle from "@/Components/TableSingle.vue";

defineProps({
    levels: Array,
    select_level: Array,
    select_level2: Array
});
const rutaprefijo = ref('level');
const modulo = ref('Nivel');
</script>

<template>

    <Head title="Nivel escolar" />

    <BreezeAuthenticatedLayout>
        <template #header>
        <PremiumPageHeader :icon="mdiCog" title="Nivel / Subnivel escolar" subtitle="Gestión de nivel / subnivel escolar">
        </PremiumPageHeader>
    </template>


        <div>
            <div class="bg-white overflow-hidden border rounded-md shadow-lg p-4">

                <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->
                <CardBox has-table>
                    <!-- Tablesingle opciones: checkable isRef ya está por defecto en modulo Nivel -->
                    <TableSingle :modulo="modulo" :data="levels" :select1="select_level" :select2="$page.props.auth.user.id_rol <= 3 ? select_level2 : []" :ruta="rutaprefijo" />
                </CardBox>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
